import { useState } from 'react';
import ReactGA from 'react-ga4';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { Button } from '../../../../components/common/buttons/Button';
import {
  IProductForInquiryModal,
  ProductInquiryModal,
} from '../../../../components/custom/modal/product/ProductInquiryModal';
import { IProductForInquiry, useHandleProductInquiry } from '../../../../hooks/product/useHandleProductInquiry';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { IProduct } from '../../../../interfaces/Product.interfaces';

type IProductForInstallmentInquiryButton = Pick<
  IProduct,
  'id' | 'category' | 'title' | 'code' | 'machine' | 'manufacturedYear' | 'operationTime'
>;

interface ProductInstallmentInquiryButton {
  product: IProductForInstallmentInquiryButton;
  pageType: 'home';
}

export const ProductInstallmentInquiryButton = ({ product, pageType }: ProductInstallmentInquiryButton) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  const [isProductInquiryModalOpen, setIsProductInquiryModalOpen] = useState<boolean>(false);

  const { handleProductInquiryButtonClick } = useHandleProductInquiry({
    product: product as IProductForInquiry,
    pageType,
  });

  return (
    <ButtonWrapper>
      <Button
        borderType={'square'}
        color={'outlinedGreyLight'}
        onClick={() => {
          ampli.pvmClickProductCardInstallmentButton({
            '매물 코드': product.code,
          });
          ReactGA.event('pvm_click_product_card_installment_button');

          handleProductInquiryButtonClick();
          if (!isUserLoggedIn) {
            setIsProductInquiryModalOpen(true);
          }
        }}
        size={'sm'}
        text={{ content: '할부 문의', size: 'md' }}
        riveAnimation={{ name: 'CircleWonAnimate', size: 'Large' }}
        icon={{ fileName: 'AngleRight', position: 'right', size: 'Medium', fill: '#505363' }}
      />

      {isProductInquiryModalOpen && (
        <ProductInquiryModal
          product={product as IProductForInquiryModal}
          pageType={'plp'}
          onModalClose={() => setIsProductInquiryModalOpen(false)}
        />
      )}
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  width: 144px;

  display: flex;
  align-items: center;

  border-radius: var(--radius-medium, 8px);
`;
